import { o2oApi } from 'yxt-biz-pc/packages/api';

// 获取项目列表
export const postProjectPlanList = ({page, size, ...params}) => {
  let offset = (page - 1) * size;
  return o2oApi.post(`/plan/module/planList?limit=${size}&offset=${offset}`, params);
};
